import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch product list
export const fetchProductList = createAsyncThunk(
  'dataAdmin/fetchProductList',
  async ({ page, per_page, event_name }, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/v1/select-product-list', {
        params: { page, limit: per_page, event_name },
      });

      return response.data; // Ensure backend response matches expected structure
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch products');
    }
  }
);

// Async thunk to upload CSV
export const uploadData = createAsyncThunk(
  'dataAdmin/uploadData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/v1/upload-data-store-data', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to upload file.');
    }
  }
);

// Async thunk to fetch product list from data store
export const fetchProductListDataStore = createAsyncThunk(
  'dataAdmin/fetchProductListDataStore',
  async ({ page, limit, event_name }, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/v1/get-upload-product-list', {
        params: { page, limit, event_name },
      });
      console.log("response44",response.data)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch products');
    }
  }
);

const dataAdminSlice = createSlice({
  name: 'dataAdmin',
  initialState: {
    data: [],
    pagination: { current_page: 1, total_pages: 1, per_page: 10, total_count: 0 },
    eventName: '',
    loading: false,
    uploadLoading: false,
    error: null,
    uploadError: null,
    uploadSuccess: null,
  },
  reducers: {
    setEventName: (state, action) => {
      state.eventName = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch product list cases
      .addCase(fetchProductList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductList.fulfilled, (state, action) => {
        state.data = action.payload.data || []; // Ensure data is always an array

        if (action.payload.pagination) {
          state.pagination = {
            current_page: action.payload.pagination.current_page || 1,
            total_pages: action.payload.pagination.total_pages || 1,
            per_page: action.payload.pagination.per_page || 10,
            total_count: action.payload.pagination.total_count || 0,
          };
        }

        state.loading = false;
      })
      .addCase(fetchProductList.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      // Upload data cases
      .addCase(uploadData.pending, (state) => {
        state.uploadLoading = true;
        state.uploadError = null;
        state.uploadSuccess = null;
      })
      .addCase(uploadData.fulfilled, (state, action) => {
        state.uploadLoading = false;
        state.uploadSuccess = action.payload.message;
      })
      .addCase(uploadData.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.payload;
      })

      // Fetch product list from data store cases
      .addCase(fetchProductListDataStore.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductListDataStore.fulfilled, (state, action) => {
        state.data = action.payload.data || []; // Ensure data is always an array
    
        state.pagination = {
          current_page: action.payload.currentPage || 1,
          total_pages: action.payload.totalPages || 1,
          total_count: action.payload.total || 0, // Fixing the total count assignment
        };
    
        state.loading = false;
    })
    
      .addCase(fetchProductListDataStore.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { setEventName, setPagination } = dataAdminSlice.actions;
export default dataAdminSlice.reducer;
